import FAQDrawer from "../components/questions/Questions"
import EligibilitySection from "../whoFits/WhoFits"
import styles from "./SixthScreen.module.css"
const SixthScreen=()=>{

return <>

<div className={styles.title}>תשובות לכל השאלות שלכן</div>
<div className={styles.description}>ריכזתי את כל השאלות שקיבלתי מכן בזמן האחרון ועניתי עליהן במסודר - לחצי על כל שאלה והתשובה תיפתח</div>

<FAQDrawer 
  question="סיימתי ממש עכשיו קורס קוסמטיקה, למה שאעשה עוד קורס?" 
  answer="אחרי שאני עברתי בעצמי עשרות קורסים ושילמתי עליהם עשרות אלפי שקלים במהלך השני הבנתי שאת החומר שתקבלי אצלי בקורס - לא תקבלי בשום מקום אחר! אמנם הקורס שעברת הכיל המון ידע אבל אני מלמדת אותך איך לקחת את הידע שצברת, בנוסף לידע שתקבלי ממני ולנהל איתו קליניקנה ריווחית ומלאה בלקוחות משלמות. אצלי תלמדי להתמודד עם כל סוגי הטיפולים, קיצורי תהליכים, חידוד המקצועיות וכל השלבים ליצירת עסק רווחי ממישהי שכבר עשתה את הדרך הארוכה בעצמה " 
/>




<FAQDrawer 
  question="מה עושים כשהקליניקה מוכנה אבל אין לי לקוחות?"
  answer="עצם העובדה שהקליניקה מוכנה זה מדהים! עכשיו זה השלב ללמוד איך להביא אליה לקוחות משלמים, לא דרך מבצעים, לא דרך מעגלי מכרים. נלמד שיווק שמביא תוצאות, נלמד איך להציג את עצמך נכון ואיך לגרום ללקוחה לבחור דווקא בך ולאורך זמן. תשאירי פרטים ואצור איתך קשר אישית" 
/>



<FAQDrawer 
  question="אני מרגישה שאין לי את הביטחון לבקש את המחיר שמגיע לי. זה משהו שאפשר ללמוד?"
  answer="בטח. וזה אפילו חלק ממה שאנחנו עושות פה. דרך כלים מ־NLP ותרגול אמיתי, את לומדת לדבר עם לקוחה מתוך ביטחון ולבקש מחיר בצורה נעימה - בלי לגמגם, ובלי להתנצל. תהי בטוחה שעם התרגול את כבר תרגישי בטחון והרצון שלך להעלות מחירים יעלה עם הזמן." 
/>


<FAQDrawer 
  question="ואם אני לא אצליח כמו כולן?"
  answer="אין פה כולן. יש אותך. והקצב שלך. אני לא מבטיחה קסמים, אני מבטיחה ליווי אמיתי, תרגול ומיקוד אישי. אם את מגיעה עם רצון - אני כבר אדאג שתצאי עם תוצאה." 
/>

<FAQDrawer 
  question="אני לא בטוחה שזה הזמן הנכון בשבילי. אולי עדיף לחכות?"
  answer="בדיוק בגלל זה עכשיו זה הזמן. אם את מרגישה תקועה, אם משהו חסר - חבל לדחות עוד חודשיים-שלושה ולהמשיך לאבד זמן וכסף. דווקא כשעולים כל החששות והפחדים - זה הזמן לפעול!" 
/>

</>
}
export default SixthScreen